/**
 * @fileoverview Componente atom/molecule para mostrar la reacción de un mensaje en el inbox.
 * @module MessageReactionMC
 * @category Component - Atom|Molecule
 * @since 1.0.0
 * @version 3.1.0
 *
 * @typedef {Object} Message
 * @description Objeto de mensaje para el inbox.
 * @property {string} reaction - Emoji o texto de reacción asociado al mensaje.
 * @property {'outbound'|'inbound'} direction - Dirección del mensaje (saliente o entrante).
 *
 * @component MessageReactionMC
 * @category Component - Atom|Molecule
 * @description
 * Componente optimizado para mostrar la reacción de un mensaje en el inbox.
 * - Muestra un emoji o texto de reacción en la posición adecuada según la dirección.
 * - Usa clases TailwindCSS con prefijo tw- y .tw-wrapper.
 * - Nivel atómico: Atom/Molecule según integración.
 *
 * @param {Object} props - Propiedades del componente.
 * @param {Message} props.message - Objeto de mensaje con reacción y dirección.
 * @returns {JSX.Element|null} Elemento JSX renderizado o null si no hay reacción.
 *
 * @example
 * // Uso básico
 * <MessageReactionMC message={{ reaction: '👍', direction: 'outbound' }} />
 *
 * @see .github/frontend/inbox/components/MessageReaction.md Documentación del componente
 */
import React from 'react';

const MessageReaction = ({ message }) => {
  if (!message.reaction) return null;

  const positionClass =
    message.direction === 'outbound'
      ? 'tw-right-2'
      : 'tw-left-2';

  return (
    <div
      className={`
        tw-absolute
        tw-bottom-0
        ${positionClass}
        tw-translate-y-1/2
        tw-bg-white
        tw-rounded-full
        tw-px-1
        tw-shadow
        tw-border
        tw-border-gray-200
        tw-text-xs
        tw-flex
        tw-items-center
        tw-justify-center
        tw-z-20
      `}
    >
      {message.reaction}
    </div>
  );
};

export default MessageReaction;